import { render, staticRenderFns } from "./PlatformSwitch.vue?vue&type=template&id=6c94ea5c&scoped=true"
import script from "./PlatformSwitch.vue?vue&type=script&lang=ts"
export * from "./PlatformSwitch.vue?vue&type=script&lang=ts"
import style0 from "./PlatformSwitch.vue?vue&type=style&index=0&id=6c94ea5c&prod&lang=scss&scoped=true"
import style1 from "./PlatformSwitch.vue?vue&type=style&index=1&id=6c94ea5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94ea5c",
  null
  
)

export default component.exports